import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,   // Don't store tokens in localStorage (stateless sub-app)
    autoRefreshToken: false,  // No refresh token cycling — session lasts until expiry
  }
})
